module.exports = __webpack_public_path__ + "media/images/remittees_5-e137ed5e83af0240de6efd1856e6b81d.jpg";